const LIMIT_DATE = 'limitDate'

export const setLimitDate = async (limitDate: string | undefined) => {
  if (limitDate) {
    const now = new Date(limitDate)
    now.setMinutes(now.getMinutes() + 15)
    localStorage.setItem(LIMIT_DATE, JSON.stringify(now))
  } else {
    removeLimitDate()
  }
}

export const getLimitDate = () => {
  return localStorage.getItem(LIMIT_DATE)
}

export const removeLimitDate = () => {
  localStorage.removeItem(LIMIT_DATE)
}

export const getTimeLeft = (_limitDate) => {
  const limitDate = new Date(JSON.parse(_limitDate))
  const now = new Date()

  const difference = limitDate.getTime() - now.getTime()

  return Math.floor(difference / 1000)
}

export const validateDateAndTime = (date: string, time: string) => {
  const appointment = new Date(date + 'T00:00:00')
  const today = new Date()
  const currentHour = today.getHours()
  const currentMinute = today.getMinutes()

  today.setHours(0, 0, 0, 0)

  if(appointment < today) {
    return false
  }

  if(appointment.getTime() !== today.getTime()) {
    return true
  }

  const [appointmentHour, appointmentMinute] = time.split('-')[0].split(':').map(Number)
  const timePassed =  currentHour > appointmentHour || currentHour === appointmentHour && currentMinute > appointmentMinute

  return !timePassed
}
